import React from "react";
import { Route, Routes } from "react-router";
import PageLayout from "../layout/PageLayout";
import AboutPage from "../pages/AboutPage";
import FaqsPage from "../pages/FaqsPage";
import LandingPage from "../pages/LandingPage";
import LegalPage from "../pages/LegalPage";
import PrivacyPage from "../pages/PrivacyPage";
import SimCollectPage from "../pages/SimCollectPage";
import SimMarketsPage from "../pages/SimMarketsPage";
import SimVerifyPage from "../pages/SimVerifyPage";


const GuestRoutes = () => {
  return (
    <Routes>
      <Route element={<PageLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/simmarkets" element={<SimMarketsPage />} />
        <Route path="/simcollect" element={<SimCollectPage />} />
        <Route path="/simverify" element={<SimVerifyPage />} />
        <Route path="/faqs" element={<FaqsPage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="*" element={<LandingPage />} />
      </Route>
    </Routes>
  );
};

export default GuestRoutes;
